import { breakpointsSematic } from '@vueuse/core';

export function useSize(force?: boolean) {
    const breakpoints = useBreakpoints({ ...breakpointsSematic, tablet: 820 });
    const isMobile = ref(true);
    const isDesktop = ref(false);
    const isMobileBreak = breakpoints.smallerOrEqual('tablet');
    const isDesktopBreak = breakpoints.greater('tablet');
    const isMounted = useMounted();
    watchEffect(() => {
        if (isMounted.value || force) {
            isMobile.value = isMobileBreak.value;
            isDesktop.value = isDesktopBreak.value;
        }
    });
    const isLaptop = breakpoints.greaterOrEqual('laptop');
    return {
        isDesktop,
        isMobile,
        isLaptop,
    };
}
